module.exports = __webpack_public_path__ + "img/download-jddetail.a5f0891b.svg";